import React, { useState } from 'react';
import {Badge } from 'reactstrap';

const SectionTextArea = ({
  title,
  questionDetail,
  className,
  listenFromHere,
  context,
  marks,
  total_q,
  total_marks,
}) => {
  const [draft, showDraft] = useState(true);
  const toggleDraft = () => {
    showDraft(!draft);
  };
  const resumeAudio = () => {
    listenFromHere('1:00'); // send this time to audio component for skipping the audio
  };
  return (
    <div className="gradient-background">
      <span className="section-title text-uppercase text-primary">{title}</span>
      {/* <br /> */}
      <span className=""> [{questionDetail}]</span>
      {/* {marks ? (
        <Badge className="rounded-0 ml-2 float-right" color="success">{`(${
          marks % 1 ? marks?.toFixed(2) : marks
        } * ${total_q} = ${total_marks})`}</Badge>
      ) : null} */}
      {marks ? (
        <Badge
          className="rounded-0 ml-2 float-right"
          color="success"
        >{`(${marks} * ${total_q} = ${total_marks})`}</Badge>
      ) : null}
      {context ? (
        <p>
          <small>
            <i>
              <div dangerouslySetInnerHTML={{ __html: context }} />
            </i>
          </small>
        </p>
      ) : (
        ''
      )}

      <div className="notepad">
        <textarea
          className={
            draft ? 'notepad-draft' : `notepad-draft show-notepad-draft ${className}`
          }
          placeholder="Your draft goes here..."
        ></textarea>
      </div>
      <div className="question-board mt-2">
        {/* <button  onClick={()=> resumeAudio()}><i className="fas fa-headphones mr-2"></i>Listen from here</button> */}
        <button onClick={() => toggleDraft()} className="btn btn-primary">
          <i className="fas fa-edit mr-2"></i>
          {draft ? 'Show Notepad' : 'Hide Notepad'}
        </button>
      </div>
    </div>
  );
};

export default SectionTextArea;